import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import AssumptionComponent from './AssumptionComponent';
import { getItemFromLocalStorage, setItemLocalStorage } from '../../../stores/tool/storage/storage';

@observer
class AssumptionsLoanpartComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setAssumptionsData = this.setAssumptionsData.bind(this);
    this.checkEmptyAssumptions = this.checkEmptyAssumptions.bind(this);
  }

  componentDidMount() {
    this.setAssumptionsData();
  }

  /* Set mortgage and nhg value from CalculationFormStore */
  setAssumptionsData() {
    const baseFormData = this.props.CalculationFormData.setBaseFormData();

    // eslint-disable-next-line react/prop-types
    this.props.SavingsData.assumptionsData.forEach((assumption) => {
      if (assumption.NHG) {
        assumption.NHG = baseFormData.nhg === 0 ? 'Nee' : 'Ja';
      }

      if (assumption.Hypotheekbedrag) {
        assumption.Hypotheekbedrag = numeral(baseFormData.mortgage).format('$ 0,00');
      }
    });
  }

  checkEmptyAssumptions(assumptionData) {
    return assumptionData.some(assumption => _.isEmpty(_.values(assumption)[0])
      || _.values(assumption)[0] === '-'
      || _.values(assumption)[0] === '€ 0');
  }

  render() {
    let assumptionsData = this.props.SavingsData.assumptionsData;

    /* Save aggregated assumptionsData when all values are filled in */
    if (!this.checkEmptyAssumptions(assumptionsData)) {
      setItemLocalStorage(assumptionsData, 'LooptijdRenteAssumptionsData');
    }

    if (this.checkEmptyAssumptions(assumptionsData)
      && !_.isEmpty(getItemFromLocalStorage('LooptijdRenteAssumptionsData'))) {
      assumptionsData = getItemFromLocalStorage('LooptijdRenteAssumptionsData');
    }

      // eslint-disable-next-line react/prop-types
    const assumptions = assumptionsData.map((data, index) => (
      <div
        className="columns medium-21"
        // eslint-disable-next-line react/no-array-index-key
        key={index}
      >
        <AssumptionComponent
          keyValue={Object.keys(data)[0]}
          value={Object.values(data)[0]}
        />
      </div>
      ));

    return (
      <div>{assumptions}</div>
    );
  }
}

AssumptionsLoanpartComponent.propTypes = {
  SavingsData: PropTypes.shape({
    assumptionsData: PropTypes.shape({}),
  }),
  CalculationFormData: PropTypes.shape({
    setBaseFormData: PropTypes.func,
  }),
};

AssumptionsLoanpartComponent.defaultProps = {
  SavingsData: {
    assumptionsData: [],
  },
  CalculationFormData: {
    setBaseFormData: () => {},
  },
};

export default inject('SavingsData', 'CalculationFormData')(AssumptionsLoanpartComponent);
